import React from "react";

const CustomInputUncontrolled = React.memo(
  ({
    label,
    placeholder,
    required,
    icon,
    iconClass,
    noMarginBottom,
    numberTypeWithoutDot = false,

    defaultValue,
    onValueCommit, // 🔑 called onBlur
    setIsPassword,

    error, // 🔑 validation message
    ...props
  }) => {
    /* ===== YOUR VALIDATION HELPERS (PRESERVED) ===== */

    const numberInputOnWheelPreventChange = (e) => {
      let isFocused = document.activeElement === e.target;

      e.target.blur();
      e.stopPropagation();

      if (isFocused) {
        setTimeout(() => e.target.focus(), 0);
      }
    };

    const numberInputKeyDownPreventChange = (e) => {
      const { key } = e;
      const keyCode = e.charCode || e.keyCode;

      if (
        keyCode === 38 || // up
        keyCode === 40 || // down
        (props.type === "number" &&
          (key === "e" || key === "+" || key === "-")) ||
        (props.type === "number" &&
          numberTypeWithoutDot === true &&
          key === ".")
      ) {
        e.preventDefault();
      }
    };

    /* ===== RENDER ===== */

    return (
      <div className={`${noMarginBottom ? "" : "mb-2"}`}>
        {label && (
          <label className="mb-1">
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}

        {icon || props.passwordEye ? (
          <div className="input-group">
            {icon && (
              <span className="input-group-text">
                <i className={iconClass}></i>
              </span>
            )}

            <input
              {...props}
              // type={type}
              // maxLength={maxLength}
              // disabled={disabled}
              defaultValue={defaultValue}
              placeholder={placeholder}
              autoComplete="off"
              className={`form-control form-control-sm ${
                props.passwordEye ? "passwordInput" : ""
              }`}
              onWheel={numberInputOnWheelPreventChange}
              onKeyDown={numberInputKeyDownPreventChange}
              onBlur={(e) => {
                onValueCommit?.(e.target.value);
              }}
            />

            {props.passwordEye && (
              <div
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setIsPassword(props.type === "password" ? false : true)
                }
                title={props.type === "password" ? "show" : "hide"}
              >
                {props.type === "password" ? (
                  <i className="fa fa-eye-slash" />
                ) : (
                  <i className="fa fa-eye" />
                )}
              </div>
            )}
          </div>
        ) : (
          <input
            {...props}
            // type={type}
            // maxLength={maxLength}
            // disabled={disabled}
            defaultValue={defaultValue}
            placeholder={placeholder}
            autoComplete="off"
            className="form-control form-control-sm mt-0"
            onWheel={numberInputOnWheelPreventChange}
            onKeyDown={numberInputKeyDownPreventChange}
            onBlur={(e) => {
              onValueCommit?.(e.target.value);
            }}
          />
        )}

        {/* 🔴 VALIDATION MESSAGE */}
        {error && (
          <div className="invalid-feedback animated fadeInUp d-block">
            {error}
          </div>
        )}
      </div>
    );
  },
);

export default CustomInputUncontrolled;
